import { useEffect } from 'react';
import { useCompassCard } from '@scale/compass-ui/store';
import type { WorkerTeamAdapterContext } from '@scale/genai-compass-shared/cards/worker_team_adapter';
import { FilterGroup, isValidFilterGroup } from '@scale/compass-shared/filter';
import _ from 'lodash';

function useWorkerTeamAdapterCard(index: number) {
  const { card, updateCardContext, updateCardCanSubmit } = useCompassCard(index);
  const context = card.defaultContext as WorkerTeamAdapterContext;

  // Ensure filter has a properly initialized structure
  const filter = context.filter ?? { operator: 'and', filtersOrFilterGroups: [] };

  const setFilter = (filter: FilterGroup) => {
    // Ensure the filter has the required structure before updating context
    const safeFilter = {
      ...filter,
      operator: filter.operator ?? 'and',
      filtersOrFilterGroups: filter.filtersOrFilterGroups ?? [],
    };

    const updatedContext: WorkerTeamAdapterContext = {
      ...context,
      filter: safeFilter,
    };
    updateCardContext(updatedContext);
  };

  const setLimit = (limitStr: string | undefined | null) => {
    let limit: number | undefined;
    if (_.isNil(limitStr) || limitStr === '') {
      limit = undefined;
    } else {
      limit = Math.max(1, +limitStr);
    }

    if (_.isNil(limit) || (limit && limit > 0)) {
      const updatedContext: WorkerTeamAdapterContext = {
        ...context,
        limit,
      };
      updateCardContext(updatedContext);
    }
  };

  useEffect(() => {
    let canSubmit = true;

    // Filter is required
    canSubmit = isValidFilterGroup(context.filter);

    updateCardCanSubmit(canSubmit);
  }, [context.filter]);

  return {
    card,
    filter,
    setFilter,
    limit: context.limit,
    setLimit,
  };
}

export default useWorkerTeamAdapterCard;
